export const EXTERNAL_NAMESPACE = '@@HDHOME';